<template>
  <div>
    <v-layout row class="white">
      <v-flex xs12 sm6 lg4>
        <v-text-field :value="search" @input="setSearch" prepend-icon="search" class="search"/>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <v-data-table :headers="headers" :items="users" :search="search" :pagination="pagination"
                      @update:pagination="setPagination" class="edval-list"><!-- TODO add loader -->
          <template slot="items" slot-scope="user">
            <td>{{ user.item.name }}</td>
            <td>{{ groupName(user.item.group) }}</td>
            <td class="buttonCell">
              <v-btn icon :to="{path: '/users/' + user.item.aoid}">
                <v-icon v-if="canEdit(user.item)">edit</v-icon>
                <v-icon v-else>visibility</v-icon>
              </v-btn>
            </td>
          </template>
          <div slot="actions" class="push-left">
            <v-subheader v-if="canSync">
              Sync Suite users
              <v-btn icon to="/users/sync">
                <v-icon color="success">autorenew</v-icon>
              </v-btn>
            </v-subheader>
            <v-subheader v-if="canExport">
              Export employees access
              <v-btn icon @click="exportEmployess()">
                <v-icon color="primary">import_export</v-icon>
              </v-btn>
            </v-subheader>
          </div>
        </v-data-table>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import { saveAs } from 'file-saver';
  import moment from 'moment';

  export default {
    data() {
      return {
        headers: [
          { text: 'Name', value: 'name', align: 'left' },
          { text: 'Group', value: 'group', align: 'left' },
          { text: '', align: 'right', sortable: false }
        ]
      };
    },
    computed: {
      canSync() {
        return this.$auth.hasPermission('SYNC_USERS');
      },
      canExport() {
        return this.$auth.hasPermission('EDIT_ALL_USERS');
      },
      groups() {
        const groups = {};
        this.$store.state.groups.groups.forEach((group) =>
          groups[group.id] = group.name
        );
        return groups;
      },
      ...mapState('users', [
        'users',
        'requiresUpdate',
        'pagination',
        'search'
      ]),
      ...mapState('auth', {
        user: 'user',
        authGroups: 'groups'
      })
    },
    methods: {
      groupName(groupId) {
        return this.groups[groupId] || groupId;
      },
      canEdit(user) {
        return this.$auth.hasPermission('EDIT_ALL_USERS') ||
          (user.group && this.authGroups.filter((g) => g.id === user.group).length) ||
          this.user.scopes.auth.servicePermissions.length ||
          this.user.sub === user.aoid;
      },
      exportEmployess() {
        this.$services.authenticator.get('/reports/users/export')
          .then((response) => {
            const blob = new Blob([response.data], { type: 'text/csv' });
            saveAs(blob, `export_employees_active_access_${moment().format('YYYYMMDDhhmmss')}.csv`);
          })
          .catch(this.$defaultHandlerHttp);
      },
      ...mapActions('users', [
        'initialize',
        'setPagination',
        'setSearch'
      ])
    },
    mounted() {
      this.initialize()
        .catch(this.$defaultHandlerHttp);
    }
  };
</script>

<style lang="less" scoped>
  @import "../../style/list.less";

  .search {
    padding: 15px;
    padding-bottom: 0;
  }
</style>
